import {
  Map,
  SlidersHorizontal,
  X,
} from "lucide-react";

import { ClientOnly } from "~/components/blocks/ClientOnly/client-only";
import AutoPlaces from "../Geosearch/AutoPlaces";
import { Workspace } from "../Geosearch/interfaces";

let priceTimer: string | number | NodeJS.Timeout | null | undefined = null
let deskTimer: string | number | NodeJS.Timeout | null | undefined = null

export async function loader({ params }: { params: any }) {
  const googleMapKey = process.env.PUBLIC_REMIX_GOOGLE_MAP;
  // Replace with your API endpoint

  return { googleMapKey: googleMapKey };
}


export default function SearchBar({
  toggleDrawer,
  setWidth,
  rightWidth,
  callGeoSearch,
  setMapLoaded,
  isCampaignPage = false,
  sticky = false,
  stickyTopClassName = 'top-[68px]',

}: {
  toggleDrawer: VoidFunction;
  setWidth: Function;
  rightWidth: number;
  setDisplayMode: Function;
  callGeoSearch: Function,
  filterData: any,
  setFilterData: Function,
  query: string,
  displayMode: string,
  workspace: Workspace,
  setMapLoaded?: Function,
  className?: string
  selectedSort: string
  setSelectedSort: Function
  isCampaignPage?: boolean
  // When true, the outermost wrapper becomes `position: sticky` so the search bar
  // stays pinned under the site header while the caller scrolls through listings.
  // IMPORTANT: place <SearchBar /> as a direct child of a tall container
  // (spanning description → listings → end-of-list) so sticky has room to travel.
  sticky?: boolean
  stickyTopClassName?: string
}) {

  function parseSearchUrl(url: string) {
    const [path, queryString] = url.split('?');
    const pathParts = path.split('/').filter(Boolean); // removes empty parts

    const [country, section, state, city] = pathParts;

    const queryParams = Object.fromEntries(new URLSearchParams(queryString));

    return {
      country,
      section,
      state,
      city,
      ...Object.fromEntries(
        Object.entries(queryParams).map(([key, value]) => {
          const num = parseFloat(value);
          return [key, isNaN(num) ? value : num];
        })
      )
    };
  }

  const handleLocationSelect = (location: string) => {
    callGeoSearch(parseSearchUrl(location))
  };

  return (
    <div
      className={
        sticky
          ? `sticky ${stickyTopClassName} z-30 bg-white border-b border-gray-100 py-1`
          : ''
      }
    >
      <div
        className={`flex items-center justify-between w-full z-40 ${isCampaignPage
          ? 'relative py-2'
          : 'h-16 border-b bg-gray-50 px-3 relative'
          }`}
      >
        {/* Office Type Dropdown */}


        <div className='flex items-center gap-4 flex-1 min-w-0'>
          {/* Location Input */}


          <div className="flex-1 min-w-0">
            <ClientOnly>
              {() => (
                <AutoPlaces
                  mobile
                  onLocationSelect={handleLocationSelect}
                  inputStyleClassName='w-full text-base'
                  fixed={false}
                  hideLocateFixed
                />
              )}
            </ClientOnly>
          </div>


          {/* Filter Button */}
          <div onClick={toggleDrawer} className='shrink-0'>
            <SlidersHorizontal className='h-6 w-6' aria-label="Filter menu" />
          </div>
          {/* <FilterDrawer /> */}


          {/* {!isCampaignPage && ( */}
          <button
            type="button"
            className='shrink-0'
            onClick={() => {
              if (setMapLoaded) {
                setMapLoaded(true)
              }
              if (rightWidth === 100) {
                setWidth(0)
              } else {
                setWidth(100)
              }
            }}
            aria-label={rightWidth === 100 ? "Close map" : "Map view"}
          >
            {rightWidth === 100 ? (
              <X className='h-6 w-6 mr-2' aria-hidden="true" />
            ) : (
              <Map className='h-6 w-6 mr-2' aria-hidden="true" />
            )}
          </button>
          {/* )} */}
        </div>
      </div>
    </div >
  );
}
